import React from "react"
import { Layout } from "../components/baselayout"
import { WhiteDiv } from "../components/whitediv"
import data from "../docs/past/past_officers.json"
const MAX_YEAR = 2020
const MIN_YEAR = 1879
const rev_range = (start, end) =>
  Array.from({ length: end - start }, (v, k) => k + start).reverse()
interface Year {
  year: number
}
interface PresidentData {
  years: string
  president: string
}
const PastOfficerEntry: React.FC<Year> = ({ year }) => (
  <tr>
    <td>
      <b>{year}</b>
    </td>
    <td>
      {data[year.toString()]["master"].map(item => (
        <p key={year.toString() + item}>{item}</p>
      ))}
    </td>
    <td>
      {data[year.toString()]["assmaster"].map(item => (
        <p key={year.toString() + item}>{item}</p>
      ))}
    </td>
    <td>
      {data[year.toString()]["secretary"].map(item => (
        <p key={year.toString() + item}>{item}</p>
      ))}
    </td>
  </tr>
)
const PresidentEntry: React.FC<PresidentData> = ({ years, president }) => (
  <tr>
    <td>
      <b>{years}</b>
    </td>
    <td>
      <p>{president}</p>
    </td>
  </tr>
)
const PastOfficers: React.FC = () => (
  <Layout title="Past Officers">
    <WhiteDiv>
      <h1 style={{ textAlign: "center" }}>Past Officers</h1>
      <h3 style={{ textAlign: "center" }}>Presidents</h3>
      <table className="outlineTable">
        <thead>
          <tr>
            <th>Years</th>
            <th>President</th>
          </tr>
        </thead>
        <tbody>
          <PresidentEntry years="2021-" president="Jonathan Agg (Emmanuel)" />
          <PresidentEntry years="2014-2021" president="Richard Smith (Clare)" />
          <PresidentEntry
            years="2006-2014"
            president="Dr Claire Y Barlow (Newnham)"
          />
          <PresidentEntry
            years="1989-2006"
            president="Dr Christopher M P Johnson (St John's)"
          />
          <PresidentEntry
            years="1961-1989"
            president="William J Ridgman (Queens')"
          />
          <PresidentEntry
            years="1937-1961"
            president="Rev A C Blyth (Selwyn)"
          />
          <PresidentEntry
            years="1879-1937"
            president="Rev A H F Boughey (Trinity)"
          />
          <PresidentEntry years="1879" president="Rev E J Heriz Smith" />
        </tbody>
      </table>
      <h3 style={{ textAlign: "center" }}>Junior Officers</h3>
      <table className="outlineTable">
        <thead>
          <tr>
            <th>Year</th>
            <th>Head Scientist</th>
            <th>Lab Assistant</th>
            <th>Secretary</th>
          </tr>
        </thead>
        <tbody>
          {rev_range(MIN_YEAR, MAX_YEAR + 1).map(yr => (
            <PastOfficerEntry year={yr} key={yr} />
          ))}
        </tbody>
      </table>
    </WhiteDiv>
  </Layout>
)

export default PastOfficers
